import { Vue, Component, Inject } from 'vue-property-decorator';
import { AppFrame } from '@/enums';
import * as I from '@/interfaces';
import AxAPI from '@/api';
import * as API from '@/api';
import moment from 'moment';

@Component
export class AxPage extends Vue implements I.AxPageBase {
  @Inject()
  getLoading!: () => boolean;

  @Inject()
  setLoading!: (b: boolean) => void;

  @Inject()
  getLoginData!: () => I.Account;

  @Inject()
  setLoginData!: (loginData: I.Account) => void;

  @Inject()
  getAppFrame!: () => AppFrame;

  @Inject()
  setAppFrame!: (frame: AppFrame) => void;

  @Inject()
  showConfirmModal!: (title: string, text: string, buttons?: string[]) => Promise<number>;

  @Inject()
  showErrorModal!: (title: string, text: string) => Promise<number>;

  @Inject()
  getZoneList!: () => I.AxZone[];

  @Inject()
  getZoneNames!: () => string[];

  @Inject()
  userLogin!: (data: I.ApiResp<I.Account>) => void;

  @Inject()
  userLogout!: () => void;

  @Inject()
  showDialog!: <T>(param: I.DialogParam<T>) => void;

  @Inject()
  API!: AxAPI;

  @Inject()
  readonly latestInfo!: I.AxLatestInfo;

  @Inject()
  isDevelopment!: boolean;

  async created() {
    this.setLoading(true);
    type WithPrepare = { prepare: Function };
    if (((this as unknown) as WithPrepare).prepare) {
      await ((this as unknown) as WithPrepare).prepare();
    }
    this.setLoading(false);
    // //스케일변경코드
    // this.$el.style.width = '100%';
    // this.$el.style.hight = '100%';
    // this.$el.style.transformOrigin = 'center';
    // this.$el.style.transform = 'scale(0.9)';
  }

  async handleTokenError(status: API.TokenStatus) {
    if (this.getAppFrame() !== AppFrame.Frame) {
      return;
    }

    switch (status) {
      case API.TokenStatus.Ok:
        break;
      case API.TokenStatus.NotExist:
        await this.showErrorModal(
          '오류',
          `유효한 엑세스 토큰이 아닙니다.<br />로그인 페이지로 돌아갑니다.`
        );
        this.userLogout();
        break;
      case API.TokenStatus.InvalidToken:
        await this.showErrorModal(
          '오류',
          `유효한 엑세스 토큰이 아닙니다.<br />로그인 페이지로 돌아갑니다.`
        );
        this.userLogout();
        break;
      case API.TokenStatus.EncryptedToken:
        await this.showErrorModal(
          '오류',
          `암호화된 토큰은 지원하지 않습니다.<br />로그인 페이지로 돌아갑니다.`
        );
        this.userLogout();
        break;
      case API.TokenStatus.Expired:
        await this.showErrorModal(
          '오류',
          `세선이 종료되었습니다.<br />로그인 페이지로 돌아갑니다.`
        );
        this.userLogout();
        break;
      default:
        await this.showErrorModal('오류', `에러: TokenStatus #${API.TokenStatus[status]}`);
        this.userLogout();
        break;
    }
  }

  async handleError(e: Error) {
    const dataNotReceived = '서버에서 데이터를 받지 못했습니다';
    if (e instanceof API.AxAPIUnauthorizedError) {
      await this.showErrorModal('오류', `세선이 종료되었습니다.<br />로그인 페이지로 돌아갑니다.`);
      this.userLogout();
    } else if (e instanceof API.AxAPIHTTPGenericError) {
      const { status, message } = e;
      await this.showErrorModal('오류', `${dataNotReceived}<br />${status} ${message}`);
    } else if (e instanceof API.AxAPIServerError) {
      const { status, message } = e;
      if (status === -13 || status === -102) {
        await this.showErrorModal('오류', `아이디 또는 비밀번호가 다릅니다`);
      } else {
        await this.showErrorModal('오류', `${dataNotReceived}<br />${status} ${message}`);
      }
    } else if (e.message === 'Failed to fetch') {
      await this.showErrorModal('오류', '서버와 통신이 불안정합니다. [웹서버 구동여부 확인필요]');
    } else {
      await this.showErrorModal('오류', `${e.message}`);
    }
  }

  generateArray(start: number, count: number) {
    return Array.from(Array(count).keys()).map(x => x + start);
  }

  formatTime(time: string, format = 'YYYY-MM-DD HH:mm:ss') {
    return moment(time).format(format);
  }

  showCodeSelectDialog(options: I.DialogOptions) {
    type CodeSelectDialogParams = { title: string; single?: boolean; param: I.DataParam };

    const { single, itemKey, showSelect } = options;

    const dialogParams = new I.DialogParam<CodeSelectDialogParams>('AxCodeSelectDialog', {
      title: options.title,
      ...{ single, itemKey, showSelect },
      param: {
        items: options.param.items,
        selected: options.param.selected,
        headers: options.param.headers || [{ text: '이름', value: 'name', align: 'start' }],
        callback: async () => {
          const selected = JSON.parse(JSON.stringify(dialogParams.props.param.selected))
            .filter((x: I.CodeData) => x.code !== '' && x.name !== '')
            .sort((a: I.CodeData, b: I.CodeData) => (a.code > b.code ? 1 : -1));

          options.param.callback(selected);
        }
      }
    });
    this.showDialog(dialogParams);
  }

  withCommas = (x: number) => x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
}
